var _defs, _g, _g2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnleeno(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-canvas",
    viewBox: "0 0 512 512",
    width: 1024,
    height: 1024,
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape_4CbkOoYwJT",
    ref: "shape_4CbkOoYwJT",
    key: "shape_4CbkOoYwJT",
    mask: ""
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-373.11899348481774,-88.60756211157337) rotate(0,628.3095094119135,523.3095094119135) scale(1,1)",
    style: {
      opacity: 1,
      mixBlendMode: "undefined"
    },
    filter: ""
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1256.619018823827,
    height: 1046.619018823827,
    viewBox: "0 0 1256.619018823827 1046.619018823827",
    "data-ligature": "true",
    "data-parent": "shape_4CbkOoYwJT",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-role": "text",
    "data-width": 353.7305223410227,
    "data-height": 149,
    transform: "translate(451.4442482414022, 448.80950941191355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.57-47.42C22.44-45.63 0.90-39.05 2.24-35.60C3.74-32.91 7.18-28.42 12.42-28.42C14.06-28.42 15.56-28.72 17.05-28.87L19.75-29.32C18.85-27.53 18.10-25.88 17.35-24.09C15.41-20.05 13.31-15.71 11.67-11.82C10.17-10.32 15.41-3.89 20.05-3.89C20.64-3.89 21.39-4.04 21.99-4.34L22.74-4.79C27.83-11.97 31.72-20.35 35.01-27.68C35.46-28.87 35.90-29.17 35.01-29.17C45.18-29.17 55.95-25.28 63.58-17.80C65.38-12.72 70.16 4.79 79.59 4.79C80.48 4.79 81.53 4.34 81.98 3.74L82.58 2.69C82.58 1.50 80.78-1.94 80.19-3.14C77.04-8.98 75.10-15.56 73.60-22.74C71.96-29.77 70.61-37.10 70.16-44.58C74.20-45.78 77.94-46.82 81.98-47.87C86.17-48.92 90.66-50.12 94.55-51.31C95.59-54.60 91.41-54.60 85.87-54.45L72.56-54.45C71.51-54.45 70.61-54.45 69.71-54.30L69.71-55.20L69.56-68.07C69.56-72.41 70.16-84.08 70.31-86.02C70.46-86.77 70.46-87.67 70.46-87.96L70.31-88.56L69.86-89.61C68.07-92.00 62.83-99.04 56.85-97.99L54.60-96.04C52.36-88.71 47.72-81.68 43.83-75.40C38.00-66.12 33.21-56.70 28.57-47.42ZM37.85-33.36L39.49-36.95C43.68-38.30 54.30-41.14 58.49-42.04C59.24-37.10 60.44-32.16 61.49-27.38C61.64-26.78 61.78-26.03 62.08-25.43C54.45-30.52 47.57-32.01 37.85-33.36ZM46.68-51.16C49.67-56.70 52.36-61.64 55.20-66.27L55.50-66.87L57.15-53.41Z",
    transform: "translate(0 134) ",
    fill: "rgb(15, 2, 75)",
    stroke: "rgb(15, 2, 75)",
    strokeWidth: 0.249,
    "data-glyph-w": 68.67904536574096,
    "data-glyph-h": 179.52,
    "data-glyph-ascender": 149.60000000000002,
    "data-glyph-descender": -29.92,
    "data-kerning": 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.07-73.30L27.38-71.21C26.93-70.31 22.89-62.83 22.14-62.38L22.59-61.78C19.15-55.05 4.19-24.38 4.79-17.65C7.63-12.57 11.97-8.68 17.35-6.43C19.90-6.43 20.79-9.42 21.54-11.22C24.53-18.40 27.53-25.73 30.67-32.91C32.76-37.70 42.49-55.35 47.27-58.04L48.02-55.65C45.93-48.32 43.53-35.01 43.53-27.08C43.53-23.79 44.58-18.25 46.53-15.56C48.77-12.57 55.80-5.39 59.84-5.39C62.53-5.39 64.78-8.68 65.97-10.77L64.93-11.82C62.68-11.82 58.64-11.37 56.55-12.27C54.16-12.27 54.30-21.54 54.75-23.04L54.45-23.79C55.50-33.81 58.79-44.13 58.79-54.30C58.79-63.43 52.96-68.67 44.88-71.66L41.89-70.91C41.14-70.31 36.35-66.27 35.46-66.12C35.46-69.56 33.06-71.96 30.07-73.30Z",
    transform: "translate(68.67904536574096 134) ",
    fill: "rgb(15, 2, 75)",
    stroke: "rgb(15, 2, 75)",
    strokeWidth: 0.249,
    "data-glyph-w": 49.53024536574095,
    "data-glyph-h": 179.52,
    "data-glyph-ascender": 149.60000000000002,
    "data-glyph-descender": -29.92,
    "data-kerning": 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.53-41.74C8.83-36.80 7.03-29.92 6.43-24.83L6.73-24.09L6.43-24.09C6.43-22.14 6.73-16.46 7.33-14.81C8.98-10.62 15.11-6.28 19.15-4.79L20.20-4.79C22.29-4.79 23.34-6.88 23.94-8.53C24.38-8.53 24.83-9.72 24.98-10.17C26.78-15.71 27.38-22.14 28.27-27.83C28.12-28.27 27.83-29.92 27.08-30.07C25.13-27.53 21.99-23.19 19.15-21.69C19.60-25.58 21.24-38.60 23.34-41.89L22.89-42.64C24.98-50.27 26.63-57.75 28.57-65.38C30.82-74.20 33.36-82.43 37.10-90.81C37.85-92.45 39.79-96.79 39.79-98.59L39.34-100.08C37.85-102.63 32.31-108.61 29.02-108.01C23.49-103.07 14.81-69.56 13.02-61.49C11.82-55.80 10.77-47.12 8.53-41.74Z",
    transform: "translate(118.20929073148191 134) ",
    fill: "rgb(15, 2, 75)",
    stroke: "rgb(15, 2, 75)",
    strokeWidth: 0.249,
    "data-glyph-w": 16.019845365740952,
    "data-glyph-h": 179.52,
    "data-glyph-ascender": 149.60000000000002,
    "data-glyph-descender": -29.92,
    "data-kerning": 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13-33.66L3.74-33.66L2.99-33.06L4.19-29.77C5.09-28.72 10.92-23.34 11.07-21.99C18.40-8.38 24.38-4.19 37.25-4.19C39.34-4.19 41.59-4.19 43.53-5.09L43.53-4.79C52.36-7.33 61.04-12.12 67.77-19.90L67.77-21.99L66.12-21.99C55.20-16.90 42.94-13.76 33.21-16.31C28.87-17.50 20.79-24.98 24.53-24.98C35.46-30.97 45.63-37.70 55.65-45.48C59.39-48.32 64.18-51.76 64.18-58.04C60.44-65.97 54.75-74.35 46.53-74.35C38.00-73.90 28.87-68.37 24.53-62.08C22.29-58.79 13.46-46.53 12.27-42.34C11.97-41.14 10.47-33.66 9.13-33.66ZM27.98-43.38L27.98-43.68C29.62-45.93 30.97-48.32 32.61-50.56C36.20-55.50 45.63-62.08 51.16-63.13L52.21-62.68L52.21-61.64C48.47-56.40 34.11-46.82 28.42-43.38Z",
    transform: "translate(126.7489776070243 134) ",
    fill: "rgb(15, 2, 75)",
    stroke: "rgb(15, 2, 75)",
    strokeWidth: 0.249,
    "data-glyph-w": 54.46704536574096,
    "data-glyph-h": 179.52,
    "data-glyph-ascender": 149.60000000000002,
    "data-glyph-descender": -29.92,
    "data-kerning": -7.480158490198559
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13-33.66L3.74-33.66L2.99-33.06L4.19-29.77C5.09-28.72 10.92-23.34 11.07-21.99C18.40-8.38 24.38-4.19 37.25-4.19C39.34-4.19 41.59-4.19 43.53-5.09L43.53-4.79C52.36-7.33 61.04-12.12 67.77-19.90L67.77-21.99L66.12-21.99C55.20-16.90 42.94-13.76 33.21-16.31C28.87-17.50 20.79-24.98 24.53-24.98C35.46-30.97 45.63-37.70 55.65-45.48C59.39-48.32 64.18-51.76 64.18-58.04C60.44-65.97 54.75-74.35 46.53-74.35C38.00-73.90 28.87-68.37 24.53-62.08C22.29-58.79 13.46-46.53 12.27-42.34C11.97-41.14 10.47-33.66 9.13-33.66ZM27.98-43.38L27.98-43.68C29.62-45.93 30.97-48.32 32.61-50.56C36.20-55.50 45.63-62.08 51.16-63.13L52.21-62.68L52.21-61.64C48.47-56.40 34.11-46.82 28.42-43.38Z",
    transform: "translate(181.21602297276524 134) ",
    fill: "rgb(15, 2, 75)",
    stroke: "rgb(15, 2, 75)",
    strokeWidth: 0.249,
    "data-glyph-w": 54.46704536574096,
    "data-glyph-h": 179.52,
    "data-glyph-ascender": 149.60000000000002,
    "data-glyph-descender": -29.92,
    "data-kerning": 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.07-73.30L27.38-71.21C26.93-70.31 22.89-62.83 22.14-62.38L22.59-61.78C19.15-55.05 4.19-24.38 4.79-17.65C7.63-12.57 11.97-8.68 17.35-6.43C19.90-6.43 20.79-9.42 21.54-11.22C24.53-18.40 27.53-25.73 30.67-32.91C32.76-37.70 42.49-55.35 47.27-58.04L48.02-55.65C45.93-48.32 43.53-35.01 43.53-27.08C43.53-23.79 44.58-18.25 46.53-15.56C48.77-12.57 55.80-5.39 59.84-5.39C62.53-5.39 64.78-8.68 65.97-10.77L64.93-11.82C62.68-11.82 58.64-11.37 56.55-12.27C54.16-12.27 54.30-21.54 54.75-23.04L54.45-23.79C55.50-33.81 58.79-44.13 58.79-54.30C58.79-63.43 52.96-68.67 44.88-71.66L41.89-70.91C41.14-70.31 36.35-66.27 35.46-66.12C35.46-69.56 33.06-71.96 30.07-73.30Z",
    transform: "translate(235.6830683385062 134) ",
    fill: "rgb(15, 2, 75)",
    stroke: "rgb(15, 2, 75)",
    strokeWidth: 0.249,
    "data-glyph-w": 49.53024536574095,
    "data-glyph-h": 179.52,
    "data-glyph-ascender": 149.60000000000002,
    "data-glyph-descender": -29.92,
    "data-kerning": 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.63-31.27C7.63-21.99 19.30-10.77 28.57-10.77C40.69-10.77 53.71-25.13 58.34-35.60C59.09-37.25 60.59-41.89 61.64-43.08L61.34-43.68C62.23-47.27 62.53-49.52 62.53-53.26L62.23-53.86L62.53-53.86C62.53-56.25 61.34-58.64 59.99-60.59C56.25-66.42 54.45-66.57 49.37-70.16C46.82-71.96 41.74-76.89 38.15-75.70L32.16-73.75C18.10-69.12 7.63-45.18 7.63-31.27ZM18.10-22.29L18.40-22.89C17.95-23.94 17.95-25.88 18.10-26.93L28.57-53.56C29.02-54.75 33.66-60.44 35.01-61.64C37.85-62.53 42.64-64.03 45.63-64.03L49.07-62.68L51.16-63.73C53.11-62.98 52.51-59.84 52.51-58.34C52.51-54.75 51.61-49.82 49.52-46.68C49.52-44.43 45.18-37.85 43.98-36.05C38.90-28.57 30.82-20.94 21.39-19.90C19.90-20.50 18.10-19.75 18.10-22.29Z",
    transform: "translate(285.2133137042471 134) ",
    fill: "rgb(15, 2, 75)",
    stroke: "rgb(15, 2, 75)",
    strokeWidth: 0.249,
    "data-glyph-w": 49.231045365740954,
    "data-glyph-h": 179.52,
    "data-glyph-ascender": 149.60000000000002,
    "data-glyph-descender": -29.92,
    "data-kerning": 0
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "shape_Bd94gxP6eL",
    ref: "shape_Bd94gxP6eL",
    key: "shape_Bd94gxP6eL",
    mask: ""
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.459900845324796,2.5157479934719618) rotate(0,198.3338384937075,182.3549275634725) scale(1,1)",
    style: {
      opacity: 1,
      mixBlendMode: "undefined"
    },
    filter: ""
  }, /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 396.667676987415,
    height: 364.709855126945,
    viewBox: "10.77982234954834 17.971683502197266 178.48501586914062 164.10523986816406",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    className: "style-removed",
    preserveAspectRatio: "none",
    "data-parent": "shape_Bd94gxP6eL",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1__dP6tuBkRBe",
    gradientUnits: "userSpaceOnUse",
    x1: 16683.9746,
    y1: -3961.6838,
    x2: 16683.9746,
    y2: -752.0266,
    gradientTransform: "matrix(5.109580e-02 0 0 -5.109580e-02 -752.481 -20.4254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {},
    stopColor: "#0b78ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    style: {},
    stopColor: "#0b78ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5608,
    style: {},
    stopColor: "#e41c87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8118,
    style: {},
    stopColor: "#f4990a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {},
    stopColor: "#fbff00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1__dP6tuBkRBe)",
    d: "M178.3,119.8c2.4-8.9,3-18.5,2-28.2c-2.3-22.5-13.5-42-29.8-55.2c-16.3-13.2-37.6-20.3-60.1-18 c-22.5,2.3-42,13.5-55.2,29.8c-13.2,16.3-20.3,37.6-18,60.1c0.4,4.3,1.2,8.5,2.3,12.5c2.3,14.3-7.9,10.1-8.7,15.2 c-0.4,2.6,5.1,10.2,20.7,8.7c3.9-0.4,19.8-0.4,18,4.9c-1.3,3.7-8.4,6.2-3.8,11.8c11.3,13.6,37.3-4.4,64,1.8 c10,1.5,30.5,7.5,47.6-3.9l1.1-0.7l0.2-0.2c1.3-2.6,0.4-3.2-1.1-3.5c-5.1-0.9-10.5-8-1.5-9.5c8.4-1.5,31.2-0.8,33.2-8.3 C190.4,132.4,174.5,134.2,178.3,119.8L178.3,119.8z M106.8,44.7c-3.6-5.7-8.3-8.1-15.1-8.1c3.1-2.3,11.4-2.1,15,2.4 c2.2-3.8,10.3-6.3,16-1.9C114.8,35.9,110.1,38.5,106.8,44.7L106.8,44.7z M110.4,72.5c-3.5-4.5-11.8-4.7-15-2.4 c6.8,0,11.5,2.4,15.1,8.1c3.3-6.2,8-8.8,15.8-7.6C120.7,66.1,112.6,68.6,110.4,72.5L110.4,72.5z M96.6,80c-5.7-4.4-13.7-1.9-16,1.9 c-3.5-4.5-11.8-4.7-15-2.4c6.8,0,11.5,2.4,15.1,8.1C84.1,81.5,88.9,78.8,96.6,80L96.6,80z M124.6,174c-3.1-4.1-18.1-5.8-27.7-5.8 c-7.8,0-18.5,2.4-22.8,5.3c-2.8,1.9-3.4,3.8,1.4,5.2c10,3,20.7,4.1,31.6,2.9c4.9-0.5,9.7-1.4,14.3-2.7 C123.3,178.3,126.8,176.9,124.6,174L124.6,174z M123,139c-16.3,6.7-40.9,2.5-54.5-4.7c-13.3-7,4.7-6.3,4.9-11.4 c0.2-4.7-19.8-1.3-21.5-18.1c-1.3-12.9,2.7-25.1,10.3-34.5C69.9,61,81,54.6,93.9,53.3c12.9-1.3,25.1,2.7,34.5,10.3 c9.3,7.6,15.8,18.7,17.1,31.6c0.8,8.1-0.4,16-3.4,23c-0.6,1.5-1.3,2.9-2,4.3c-2.3,8.1,6.3,5.2,3.8,8.9c-2.5,3.7-11.8-0.6-20.6-0.7 c-7.2-0.1-10.8,3-8,4.4C118.1,136.4,125,135,123,139L123,139z",
    strokeWidth: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnleeno);
export default __webpack_public_path__ + "static/media/Anleeno.9fa3d9e12fb6614554007d3ee4672bfb.svg";
export { ForwardRef as ReactComponent };